import $ from 'jquery';
import {Swiper, Pagination} from 'swiper/js/swiper.esm.js';
Swiper.use([Pagination]);

const testimonialSwiper = new Swiper('.swiper-testimonial', {
	loop: true,
	autoplay: true,
	slidesPerView: 1,
	spaceBetween: 0,
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
	breakpoints: {
		900: {
			slidesPerView: 2,
			spaceBetween: 50,
		}
	}
});
